import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import moment from 'moment';
import iconPath from "../../../helpers/iconHelper";
import FeedFooterLike from "../../FeedContainer/FeedFooterLike";
import Imagemodal from "../../FeedContainer/FeedImage/Imagemodal";
import { cloudinaryFileUploader } from './../../../helpers/cloudinaryFileUploader';
import { editAlbumRequest } from '../../../actions/mediaAction';
import { loader } from '../../../actions/utils';
import {encrypt} from "../../../helpers/CryptoJs";
import { getlanguagelist } from "../../../helpers/changelanguage";

import $ from "jquery";


class AlbumEdit extends Component {
    constructor(props) {
      super(props);
      this.state = {
        albumId            : this.props.albumId,
        albumMedia         : this.props.albumMedia,
        albumReaction      : this.props.albumReaction,
        currentActiveImage : null,
        album_name         : '',
        carousalFeed       : 0,
        albumList          : [],
        albumuploadList    : [],
        rawFile            : [],
        onlyNew            : [],
        create_preview     : [],
      };
     this.scrollto     = this.scrollto.bind(this);
     this.openModal    = this.openModal.bind(this);
     this.changeFile   = this.changeFile.bind(this);
     this.handleChange = this.handleChange.bind(this);
     this.removeImage  = this.removeImage.bind(this);
     this.onSubmit     = this.onSubmit.bind(this);
     this.fileUpload   = this.fileUpload.bind(this);
     this.formSubmit   = this.formSubmit.bind(this);
    }
    componentDidMount() {
        
    }
    UNSAFE_componentWillReceiveProps(nextProps,prevProps){
        let albumList = [];
        if(this.props.editAlbum != nextProps.editAlbum){
            this.setState({
                albumList       : [],
                albumuploadList : []
            })
            this.props.changeView('view',this.state.albumId);
        }else{
            if((nextProps.albumMedia.album_media != undefined) && (Object.keys(nextProps.albumMedia.album_media).length > 0)){
                nextProps.albumMedia.album_media.map((tile,index) => {
                    let currentMedia = {
                        media_link : tile.media_link,
                        gallery_id : tile.media_id,
                        media_type : tile.media_type,
                    }
                    albumList.push(currentMedia);
                })
                this.setState({
                    albumList       : albumList,
                    albumuploadList : albumList
                })
            }
            this.setState({
                album_name : nextProps.albumMedia.album_name
            })
        }
        
    }
    scrollto(){
        $('html, body').animate({
            'scrollTop' : $("#scrollto").position().top
        });
    }
    openModal(index){
        let carousalArray = [];
        let new_res = this.state.albumuploadList;
        var removeIndex = new_res.map(function(item) { return item.gallery_id; 
            
        }).indexOf("");
        new_res.splice(removeIndex, 1);
        carousalArray.push(new_res[removeIndex]);
       
        this.setState({
            currentActiveImage : index, 
            carousalFeed       : '499'
        })
    }
    handleChange(e) {
        this.setState({
          [e.target.name]: e.target.value,
        });
    }
    removeImage(removeIndex) {
       let afterRemove = this.state.albumList;
        afterRemove.splice(removeIndex, 1);
        this.setState({
            albumList : afterRemove
        });
    }
    changeFile(e){
        let count = 0;
        let total_file_arr = e.target.files;
        let create_preview = this.state.albumList;

        for (let i = 0; i < (total_file_arr.length); i++) { 
         
          let file = e.target.files[i];
          console.log(file);
          let reader = new FileReader();
          let url = reader.readAsDataURL(file);
          
          reader.onloadend = function (e) {
            //console.log(reader.result);
            let currentMedia = {
                media_link : reader.result,
                gallery_id   : '',
                media_type : file.type.match('image.*') ? 'IMAGE' : 'VIDEO'
            }
            create_preview.unshift(currentMedia);
            this.setState({
                albumList : create_preview
            });
         }.bind(this);
         
           
         
        }
       
    }

    onSubmit(e){

        e.preventDefault();
        let rawFile = [];
        if(this.state.albumList.length > 0){
            const uploaders = this.state.albumList.map(file => {
                if(file.gallery_id == ''){
                    rawFile.push(file.media_link);
                }
            })
            this.fileUpload(rawFile);  
        }else{
            
          this.setState({isLoading: true})
          this.formSubmit();
        }
    };
    
    fileUpload(files){
        loader(true);        
        let new_res = this.state.albumuploadList;  
        new_res = new_res.filter(function(returnableObjects){
            return returnableObjects.gallery_id != '';
        });
             
        let uploadResponse = [];
        let uploadPath = `uploads/${this.props.currentUserDetails.user.id}/album_image_path`;
        uploadResponse = cloudinaryFileUploader(files,uploadPath,"IMAGE");
       
       uploadResponse.then((response)=>{
          response.map(res => {
            new_res.unshift({'media_link':`${res.data.public_id}.${res.data.format}`,'gallery_id':'','media_type':(res.data.resource_type).toUpperCase()});
          })
          this.setState({
            albumuploadList: new_res
          });
          this.formSubmit();
        }); 
    }
    formSubmit(){
      
        let param = {
            album_id    : this.state.albumId,
            album_title : this.state.album_name,
            media_files : this.state.albumuploadList
        } 
        this.props.editAlbumRequest(param);
    }
    render() {
           
   // let create_preview    = this.state.create_preview;
    let albumMedia    = this.state.albumList;
    let albumReaction = this.state.albumReaction;
    let albumDtl      = this.state.albumMedia;
    let  languagelist = getlanguagelist();

    return (
       
        <div className="content_area">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 post_area">

                    <div className="gallery_area">
                        <h3 className="pull-left album_heading"> 
                            <input type="text" placeholder={languagelist.albumtitle} name="album_name" value={(this.state.album_name != undefined) ? this.state.album_name : ''} onChange={this.handleChange} /> 
                        </h3>
                        <ul className="album_lsc pull-right">
                           {/*  <li>
                              
                                { (albumMedia.album_media != undefined) ?
                                <FeedFooterLike 
                                    total_reaction={albumReaction.total_reaction} 
                                    my_reaction={albumReaction.my_reaction} 
                                    data_type='ALBUM' 
                                    feed_id={albumMedia.feed_id}
                                    position='post'
                                />
                                : null }
                            </li>
                            <li>|</li>
                            <li>
                                <a href={void(0)} onClick={this.scrollto}><img src="/assets/images/new_timeline_comment2.png" />
                                {albumReaction.total_comment}
                                </a>
                            </li>
                            <li>|</li>
                            <li>
                                <a href={void(0)}><img src="/assets/images/new_timeline_share2.png" />
                                {albumReaction.total_share}
                                </a>
                            </li> */}
                        </ul>

                        <div className="gallery_content_area">
                            <div className="gallery_section" id="section1">
                                <ul>

                                    
                                    { (albumMedia != undefined) && (Object.keys(albumMedia).length > 0) ?
                                        albumMedia.map((tile,index) => { 
                                            let previous_type = albumMedia[index].media_link;
                                            return(
                                                <li key={`album_media${index}`} >
                                                    <a href={void(0)} className="remove_image" onClick={()=>this.removeImage(index)}><i className="far fa-trash-alt"></i></a>
                                                    <a className="portfolio_box" href={void(0)}>
                                                        {
                                                            (tile.media_type == 'IMAGE') ?
                                                            <img src={(tile.media_link != '') ? tile.media_link : iconPath['BREAKIMAGE']} 
                                                                onError = {(e) => {
                                                                    e.target.src = iconPath['BREAKIMAGE']
                                                                }} 
                                                            />
                                                            : 
                                                           
                                                                <video controls className="carousal-video" controlsList="nodownload" src={tile.media_link}>
                                                                   
                                                                </video>
                                                            }
                                                    </a>
                                                </li>
                                            )
                                            media_v = '';
                                        })
                                        : null
                                    }
                                </ul>
                                <center> <input type="button" className="btn_5" value={languagelist.save} onClick={this.onSubmit}/></center>
                                <a href="#" className="add_image_icon">
                                    <div className="custom-file">
                                        <input type="file" className="custom-file-input" id="customFile" style={{display:'none'}} onChange={this.changeFile} multiple accept="image/*,video/*"/>
                                        <label className="custom-file-label" htmlFor="customFile"><img src={iconPath['LARGEADD']} /></label>
                                    </div>
                                </a>
                            </div>
                        
                            
                        </div>
                    </div>
                    {
                        (this.state.currentActiveImage != null) ?
                       
                            <Imagemodal 
                                currentActiveImage = {this.state.currentActiveImage}
                                carousalFeed       = {albumDtl.feed_id}
                                post_my_reaction   = 'LIKE'
                                post_total_reaction= '0'
                                post_total_comment = '0'
                                post_total_share   = '0'
                            />
                       
                       
                    : null
                    }
            </div>
        </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    currentUserDetails : state.login, 
    editAlbum          : state.createalbum.newAlbum 
    
  }
}
const mapDispatchToProps = dispatch => {
  return {
   
    editAlbumRequest : bindActionCreators(editAlbumRequest, dispatch)
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AlbumEdit));

